import { Component, OnInit, EventEmitter } from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'particle-date-cell-viewer',
  templateUrl: './date-cell-viewer.component.html',
  styleUrls: ['./date-cell-viewer.component.scss']
})
export class DateCellViewerComponent implements OnInit, CellComponent {
  sourceType?: string;
  valueChanged?: EventEmitter<any>;
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  disabled: boolean;

  constructor() { }

  ngOnInit() {
  }

}
